/** Компонента для отображения значений из триплета по умолчнию 
 * 1. Используются результат запроса вида PredicatSubjectRequest из request.js
 * 2. Результатом является два столбца с именем predicat и object
 * 3. Отображается либо одно значение либо массив значений, сформированный JSON.stringify(data)
*/
import React from 'react';
import { getValues } from '../../virtuoso/helper'

/** Отображение значения по умолчанию. Получается список всех доступных значения, фильтруется по языку. */
export const MakeDefaultValue = ({uri, lang, values}) => {
  //console.log("MakeDefaultValue", uri, lang, values);
  return AdvMakeDefaultValue ({uri, lang, values, predicatVar:"predicat", objectVar: "object"});
}

export const AdvMakeDefaultValue = ({uri, lang, values, predicatVar, objectVar}) => {
  return getValues(uri, lang, values, predicatVar, objectVar);
}

export class BaseViewLiteralComponent extends React.Component {
  render(){
    return(
      <MakeDefaultValue {...this.props} />
    )
  }
}